// Source/HubSpot/Field.ts
class HubSpot_Field extends HTMLElement {
  controller;
  disconnectedCallback() {
    this.controller.abort();
  }
  connectedCallback() {
    this.controller = new AbortController;
  }
  get $input() {
    return this.querySelector(`input,textarea`);
  }
  get objectId() {
    return this.dataset.objectId;
  }
  get data() {
    const input = this.$input;
    return {
      objectTypeId: this.objectId,
      value: input.value,
      name: input.name
    };
  }
}

// Source/HubSpot/Send.ts
var endpoint = `https://shopnative-website-utils-77b1df8a40b9.herokuapp.com/forms/submissions`;
var APIRequest = new Request(endpoint, {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  }
});
async function sendData(data) {
  const body = JSON.stringify(data);
  console.debug("HubSpot::Payload", data);
  const response = await fetch(APIRequest, { body });
  console.debug("HubSpot::Response", response);
  if (response.status !== 200)
    throw new Error(`HubSpot submission failed with status ${response.status}`);
  let result = {};
  try {
    result = await response.json();
  } catch {
    return {};
  }
  if (typeof result === "object" && result !== null && "redirectUri" in result && typeof result.redirectUri === "string" && result.redirectUri.trim() !== "")
    return {
      redirectUri: result.redirectUri
    };
  return {};
}

// Source/HubSpot/Form.ts
class HubSpot_Form extends HTMLElement {
  controller;
  submitting = false;
  disconnectedCallback() {
    this.controller.abort();
  }
  connectedCallback() {
    this.controller = new AbortController;
    this.listen();
  }
  listen() {
    const { signal } = this.controller;
    const submit = this.submit.bind(this);
    this.$form.addEventListener("submit", submit, { signal });
  }
  async submit(event) {
    event.preventDefault();
    if (this.disabled || this.submitting)
      return;
    const { portalId, formId } = this;
    const fields = this.$fields.map((field) => field.data);
    const data = {
      portalId,
      formId,
      fields,
      pageName: document.title,
      pageUri: location.href
    };
    console.debug("HubSpot::Form::Submit", data, {
      active: this.isActive
    });
    if (!this.isActive)
      return;
    this.setLoading(true);
    this.setError(false);
    const minimumLoadingTime = new Promise((resolve) => setTimeout(resolve, 1500));
    let redirect = null;
    try {
      const { redirectUri } = await sendData(data);
      const redirectTarget = redirectUri ?? this.fallbackRedirect;
      if (redirectTarget === "")
        throw new Error("HubSpot form has no redirect destination");
      const responseRedirect = new URL(redirectTarget, location.href);
      if (responseRedirect.protocol !== "http:" && responseRedirect.protocol !== "https:")
        throw new Error("HubSpot submission returned an invalid redirect URL");
      redirect = responseRedirect;
    } catch (error) {
      console.error("HubSpot::Form::Error", error);
    } finally {
      await minimumLoadingTime;
      this.setLoading(false);
    }
    if (redirect) {
      location.assign(redirect.href);
      return;
    }
    this.setError(true);
  }
  setLoading(loading) {
    this.submitting = loading;
    this.$form.setAttribute("aria-busy", String(loading));
    this.$submit.disabled = loading;
    this.$submitButton.toggleAttribute("data-loading", loading);
  }
  setError(visible) {
    this.$error?.toggleAttribute("hidden", !visible);
  }
  get $fields() {
    const list = this.querySelectorAll(`hubspot-field`);
    return Array.from(list);
  }
  get $form() {
    return this.querySelector(`form`);
  }
  get $submitButton() {
    return this.querySelector(`.HubSpot-Submit`);
  }
  get $submit() {
    return this.$submitButton.querySelector(`input[type='submit']`);
  }
  get $error() {
    return this.$submitButton.parentElement?.querySelector(`.HubSpot-Submit-Error`);
  }
  get isActive() {
    return this.dataset.active === "true";
  }
  get portalId() {
    return this.dataset.portalId;
  }
  get formId() {
    return this.dataset.formId;
  }
  get fallbackRedirect() {
    return this.dataset.fallbackRedirect ?? "";
  }
  get disabled() {
    return this.ariaDisabled == "true";
  }
}

// Source/HubSpot/mod.ts
customElements.define("hubspot-form", HubSpot_Form);
customElements.define("hubspot-field", HubSpot_Field);
